import { Button } from 'components/atoms';
import LabelFormStep from 'components/templates/label-form-step/LabelFormStep';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { PiCheck, PiNote, PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetLabel } from 'services/labels';
import { ILabelForm, LABEL_STATUS } from 'services/labels/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const LabelFinalStep = () => {
  const { t } = useTranslation();
  const formik = useFormikContext<ILabelForm>();
  const navigate = useNavigate();

  const label = useGetLabel(false);

  const onSubmit = async (status: LABEL_STATUS) => {
    await formik.setFieldValue('labelStatus', status);
    // formik.handleSubmit();
    await formik.submitForm();
  };

  return (
    <LabelFormStep
      header={t('label.form.final.header')}
      description={t('label.form.final.description')}>
      <Button
        variant={BUTTON_VARIANT.submit}
        fullWidth
        onClick={() => onSubmit(LABEL_STATUS.duringVerification)}
        disabled={formik.status?.isLoading}
        isLoading={formik.status?.isPending}>
        <Button.Text text={t('button.send-to-verification')} />
        <Button.Icon icon={<PiCheck />} />
      </Button>
      {(!label.data || label.data?.labelStatus === LABEL_STATUS.draft) && (
        <Button
          fullWidth
          variant={BUTTON_VARIANT.background}
          onClick={() => onSubmit(LABEL_STATUS.draft)}
          disabled={formik.status?.isLoading}
          isLoading={formik.status?.isPending}>
          <Button.Text text={t('button.save-as-draft')} />
          <Button.Icon icon={<PiNote />} />
        </Button>
      )}
      <div />
      <div />
      {label.data && (
        <Button
          fullWidth
          variant={BUTTON_VARIANT.background}
          onClick={() => navigate('/label')}>
          <Button.Text text={t('button.cancel')} />
          <Button.Icon icon={<PiX />} />
        </Button>
      )}
    </LabelFormStep>
  );
};

export default LabelFinalStep;
